/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Include4_SubInputs */

const es_landing_price_include4_sub = /** @type {(inputs: Landing_Price_Include4_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La gestionamos solo si quieres, nuestra gestión es gratis`)
};

const gl_landing_price_include4_sub = /** @type {(inputs: Landing_Price_Include4_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xestionámola só se queres; a nosa xestión é de balde`)
};

const en_landing_price_include4_sub = /** @type {(inputs: Landing_Price_Include4_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We handle it only if you want — our management is free`)
};

/**
* | output |
* | --- |
* | "We handle it only if you want — our management is free" |
*
* @param {Landing_Price_Include4_SubInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_include4_sub = /** @type {((inputs?: Landing_Price_Include4_SubInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Include4_SubInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_include4_sub(inputs)
	if (locale === "en") return en_landing_price_include4_sub(inputs)
	return es_landing_price_include4_sub(inputs)
});